import React, { useState } from "react";
import logo from "../logo.svg";
import { useTranslation } from "react-i18next";
import "../i18n"
import Icon from "./Icons";

const Header = () => {
  const { t, i18n } = useTranslation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const navItems = [
    { id: "services", label: t("services") },
    { id: "approach", label: t("approach") },
    { id: "contact", label: t("contact") },
  ];

  const changeLanguage = () => {
    i18n.changeLanguage(i18n.resolvedLanguage === "en" ? "pt-BR" : "en");
  };

  const scrollTo = (id) => {
    setDrawerOpen(false);

    if (id === "home") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <>
      <header className="site-header">
        <div className="page-container site-toolbar">
          <button type="button" className="brand-button" onClick={() => scrollTo("home")}>
            <img
              src={logo}
              className="brand-logo"
              alt="L3 Route"
              width="153"
              height="32"
              decoding="async"
            />
          </button>

          <nav className="desktop-nav" aria-label="Principal">
            <button type="button" onClick={() => scrollTo("home")}>{t("home")}</button>
            {navItems.map((item) => (
              <button type="button" key={item.id} onClick={() => scrollTo(item.id)}>
                {item.label}
              </button>
            ))}
          </nav>

          <div className="header-actions">
            <button
              type="button"
              className="language-button"
              onClick={changeLanguage}
            >
              <Icon name="translate" />
              <span>{i18n.resolvedLanguage === "en" ? "EN" : "PT"}</span>
            </button>

            <button
              type="button"
              className="header-cta"
              onClick={() => scrollTo("contact")}
            >
              <span>{t("talk_to_us")}</span>
              <Icon name="arrowRight" />
            </button>

            <button
              type="button"
              className="menu-button"
              aria-label={t("open_menu")}
              aria-expanded={drawerOpen}
              onClick={() => setDrawerOpen(true)}
            >
              <Icon name="menu" />
            </button>
          </div>
        </div>
      </header>

      {drawerOpen && (
        <>
          <div
            className="drawer-backdrop is-open"
            onClick={() => setDrawerOpen(false)}
          />
          <aside className="site-drawer is-open" aria-label="Menu">
            <div className="drawer-toolbar">
              <img
                src={logo}
                className="drawer-logo"
                alt="L3 Route"
                width="134"
                height="28"
                decoding="async"
              />
              <button
                type="button"
                className="drawer-close"
                aria-label={t("close_menu")}
                onClick={() => setDrawerOpen(false)}
              >
                <Icon name="close" />
              </button>
            </div>
            <nav className="drawer-nav" aria-label="Menu">
              <button type="button" onClick={() => scrollTo("home")}>{t("home")}</button>
              {navItems.map((item) => (
                <button type="button" key={item.id} onClick={() => scrollTo(item.id)}>
                  {item.label}
                </button>
              ))}
            </nav>
          </aside>
        </>
      )}
    </>
  );
}

export default Header;
